/**
 * Codmonアイコンボタンディレクティブ
 *
 * @description
 * このディレクティブは、アイコンのみのボタンを提供します。バリアント、サイズ、クリックイベントなどを設定可能です。
 *
 * @example
 * // プライマリバリアント、ミディアムサイズのアイコンボタン
 * <codmon-icon-button
 *   variant="primary"
 *   size="medium"
 *   on-click="handleClick()"
 *   icon-name="close-outline">
 * </codmon-icon-button>
 *
 * @example
 * // セカンダリバリアント、ラージサイズのアイコンボタン
 * <codmon-icon-button
 *   variant="secondary"
 *   size="large"
 *   on-click="handleEdit()"
 *   icon-name="create-outline">
 * </codmon-icon-button>
 *
 * @property {string} variant - ボタンの種類を指定 (例: Emphasized, Neutral, Caution)
 * @property {string} size - ボタンのサイズを指定 (例: xsmall, small, medium)
 * @property {boolean} [ngDisabled=false] - ボタンの無効化状態を指定
 * @property {Function} onClick - ボタンのクリックイベントを指定
 * @property {string} iconName - ボタン内のアイコンを指定（必須）
 * @property {boolean} [outline=false] - 枠線の表示を指定 (Outline / Icon Only の切り替え)
 * @property {string} [ariaLabel] - スクリーンリーダー向けのラベル
 */
angular.module('inspinia').directive('codmonIconButton', () => {
  return {
    restrict: 'E',
    scope: {
      variant: '@',
      ngDisabled: '=?',
      size: '@',
      onClick: '&',
      iconName: '@',
      outline: '<?',
      ariaLabel: '@',
    },
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_icon_button.html?${new Date().getTime()}`,
    link($scope) {
      // デフォルト値の設定
      $scope.ngDisabled = !!$scope.ngDisabled;
      $scope.outline = !!$scope.outline;

      const buttonSizes = ['xsmall', 'small', 'medium'];
      $scope.size = buttonSizes.includes($scope.size) ? $scope.size : 'medium';

      const buttonVariants = ['emphasized', 'neutral', 'caution'];
      $scope.variant = buttonVariants.includes($scope.variant) ? $scope.variant : 'emphasized';

      // アイコン名のバリデーション
      if (!$scope.iconName) {
        throw new Error('iconName is required for codmon-icon-button');
      }

      // クリックイベント
      $scope.onClickCodmonIconButton = () => {
        if (!$scope.ngDisabled && $scope.onClick) $scope.onClick();
      };

      // CSSクラス名を返す
      $scope.codmonIconButtonClasses = () => {
        const buttonClasses = {
          'codmon-icon-button': true,
        };
        if ($scope.variant) {
          buttonClasses[`codmon-icon-button--${$scope.variant}`] = true;
        }
        if ($scope.size) {
          buttonClasses[`codmon-icon-button--${$scope.size}`] = true;
        }
        if ($scope.outline) {
          buttonClasses['codmon-icon-button--outline'] = true;
        }
        return buttonClasses;
      };

      // アイコンサイズを返す
      $scope.codmonIconSize = () => {
        switch ($scope.size) {
          case 'xsmall':
            return { width: '20', height: '20' };
          case 'small':
            return { width: '24', height: '24' };
          case 'medium':
          default:
            return { width: '24', height: '24' };
        }
      };
    },
  };
});
